import Region from '@/creditflowresearch/domain/Region';
import { EM_LINKED_REGION_IDS } from '@/creditflowresearch/domain/Market/constants';

export const EM_FILTER_REGION_IDS: string[] = EM_LINKED_REGION_IDS;

export const EM_BETA_REGION_IDS: string[] = [Region.APAC_ID, Region.EMEA_ID];
